<template>
    <button class="btn btn-danger" type="button">
        <i class="m-0 trash icon"></i>
    </button>
</template>

<script>
export default {
    name: 'ButtonDelete',
}
</script>

<style scoped>
.btn{
  border-right: 5px !important;
}
</style>